/* tslint:disable:no-trailing-whitespace */
import { Component, OnInit } from '@angular/core';
import {MessageSeriesSelected} from '../../messages/message-series-selected';
import {DoraProperty, DoraPropertyArray} from '../../Decorators/Decorator';
import {MessageRowsSelected} from '../../messages/message-rows-selected';
import {Id} from '../dora-row/data/id';
import {DataSeries} from '../../DoraData/data-series';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {DataType} from '../../pusblisher/ipublisher';
import {TUPLA_TYPE} from '../../DoraData/data-base';
import {PublisherParameter} from '../widget-base/data/publisher-parameter';
import {RowToSubscribe} from '../dora-series-from-grid/data/row-to-subscribe';
import {FixedSeriesInfo} from '../../messages/data/fixed-series-info';
import {DataRow} from '../../DoraData/data-row';
import {ReadResult} from '../../pusblisher/data/read-result';
import {MessageLastDate} from '../../messages/message-last-date';

@Component({
  selector: 'dora-series-from-row',
  template: ''
})
export class DoraSeriesFromRowComponent extends WidgetBaseComponent {
  @DoraPropertyArray (Id)
  private idrows: Id[] = [];

  @DoraPropertyArray (Id)
  // if present is the list of colors to use for the rows. If colors are less than rows, the colors are repeated
  private colors: Id[] = [];

  @DoraProperty
  // if true, the series start point are aligned to the row with the highest date
  private seriesStartPointAligned = false;

  @DoraProperty
  // if true calculate last date from idrows series
  private calculateLastDate = false;


  private lastDate: Date = null;

  private idrowsSelected: RowToSubscribe[] = [];

  // fixed series to build
  private fixedSeriesInfos: FixedSeriesInfo[] = [];

  private series: DataSeries[] = [];
  onParameterInjectedFinished() {
    super.onParameterInjectedFinished();

    // Insert all idrows in idrowsSelected
    this.insertIdRows();

    // this is the first read: read all historical data of idrows and calculate last date
    this.readData(true);

    // subscribe to MessageRowsSelected
    this.messageService.getMessage(this.EventChannel, MessageRowsSelected, this.CallerName).subscribe(message => {
      const dataRows: DataRow[] = [];

      (message.data as MessageRowsSelected).DataRows.forEach(dataRow => {
        dataRows.push(dataRow);
      });

      this.fixedSeriesInfos = (message.data as MessageRowsSelected).FixedSeriesInfos;

      // Insert all idrows in idrowsSelected
      this.insertIdRows();

      // Convert idRows into Id[] and add to idrowsSelected
      dataRows.forEach(dataRow => {
        const rowToSubscribe = new RowToSubscribe(dataRow, (message.data as MessageRowsSelected).PublisherParameters);

        this.idrowsSelected.push(rowToSubscribe);
      });

      // this isn't the first read: read all historical data without calculate last date
      this.readData(false);
    });

  }

  protected readData(calculateEndDate: boolean): void {
    this.series = [];
    // read all historical data of idrowsSelected
    this.idrowsSelected.forEach(rowToSubscribe => {
      // tslint:disable-next-line:max-line-length
      this.read([rowToSubscribe.DataRow.Id], DataType.HISTORICAL, this.getPublisherParameters(rowToSubscribe.PublisherParameters), rowToSubscribe.DataRow.Color).subscribe((data: any) => {
        if (data !== null) {
          const readResult = (data as ReadResult);
          if (readResult.Data !== null) {
            const dataSeries: DataSeries = (readResult.Data as DataSeries);

            // set color to series if any
            if (readResult.CallerData !== null) {
              dataSeries.Color = readResult.CallerData;
            }

            this.series.push(dataSeries);
            this.onNewData(calculateEndDate);
          }
        }
      });
    });
  }

  protected onNewData(calculateEndDate: boolean): void {
    // check if all series are ready
    if (this.series.length === this.idrowsSelected.length) {
      const seriesOrdered: DataSeries[] = [];

      // allign series start point
      this.allignSeriesStartEndPoint();

      // insert series in the same order of idrowsSelected
      this.idrowsSelected.forEach(rowToSubscribe => {
        seriesOrdered.push(this.series.find(series =>
          series.SubscribeId === rowToSubscribe.DataRow.Id));
      });

      // add fixed series
      const fixedSeries = this.buildFixedSeries();
      fixedSeries.forEach(series => {
        seriesOrdered.push(series);
      });

      // fire event
      this.messageService.sendMessage(this.EventChannel, new MessageSeriesSelected(seriesOrdered), this.CallerName);


      // calculate last date
      if (calculateEndDate) {
        this.calculateEndDate();
      }
    }
  }
  private calculateEndDate(): void {
    if (this.calculateLastDate) {
      // get the last high start date from all series
      let highEndDate: Date = null;

      // consider only series with subscribeId in idrows
      const series = this.series.filter(serie => {
        return this.idrowsSelected.find(idrow => {
          return idrow.DataRow.Id === serie.SubscribeId;
        }) !== undefined;
      });

      series.forEach(serie => {
        const tuplaTimestamp = (serie.DataRows[serie.DataRows.length - 1].getDataTupla('Timestamp').Value as Date);
        if (highEndDate === null || tuplaTimestamp > highEndDate) {
          highEndDate = tuplaTimestamp;
        }
      });

      this.lastDate = highEndDate;

      // send message
      this.messageService.sendMessage(this.EventChannel, new MessageLastDate(highEndDate), this.CallerName);

    }
  }
  private allignSeriesStartEndPoint(): void {
    if (this.seriesStartPointAligned && this.series.length > 1) {
      // get the first high start date from all series
      let highStartDate: Date = null;


      this.series.forEach(series => {
        const tuplaTimestamp = (series.DataRows[0].getDataTupla('Timestamp').Value as Date);
        if (highStartDate === null || tuplaTimestamp > highStartDate) {
          highStartDate = tuplaTimestamp;
        }
      });

      // remove tuplas from series that are before highStartDate
      this.series.forEach(series => {
        while (series.DataRows.length > 0 && (series.DataRows[0].getDataTupla('Timestamp').Value as Date) < highStartDate) {
          series.DataRows.shift();
        }
      });

    }

    if (this.lastDate !== null) {
      // remove tuplas from series that are after lastDate
      this.series.forEach(series => {
        // tslint:disable-next-line:max-line-length
        while (series.DataRows.length > 0 && (series.DataRows[series.DataRows.length - 1].getDataTupla('Timestamp').Value as Date) > this.lastDate) {
          series.DataRows.pop();
        }
      });
    }
  }
  private isCompareChart(): boolean {
    return this.series.length > 1;
  }
  private buildFixedSeries(): DataSeries[] {
    const result: DataSeries[] = [];

    // get first and last roes from first stockSeries
    const firstRowOrg = this.series[0].DataRows[0];
    const lastRowOrg = this.series[0].DataRows[this.series[0].DataRows.length - 1];

    // build fixed series
    this.fixedSeriesInfos.forEach(fixedSeriesInfo => {
      const fixedSeries = new DataSeries();

      // build fixedSeries
      fixedSeries.DataType = 'Row';
      fixedSeries.Description = fixedSeriesInfo.name;
      fixedSeries.Id = fixedSeriesInfo.name;
      fixedSeries.Language = this.series[0].Language;
      fixedSeries.Units = this.series[0].Units;
      fixedSeries.TuplasDescription = this.series[0].TuplasDescription;
      fixedSeries.Color = fixedSeriesInfo.color;
      fixedSeries.FixedSeries = true;

      // build first row
      const firstRow = firstRowOrg.clone();
      const lastRow = lastRowOrg.clone();
      if (fixedSeriesInfo.type === TUPLA_TYPE.NUMBER) {
        // fixed value
        firstRow.getDataTupla('Close').Value = fixedSeriesInfo.value;
        lastRow.getDataTupla('Close').Value = fixedSeriesInfo.value;
      } else {
        // percentage value
        // tslint:disable-next-line:max-line-length
        firstRow.getDataTupla('Close').Value = this.isCompareChart() ? fixedSeriesInfo.value * 100 : firstRowOrg.getDataTupla('Close').Value * fixedSeriesInfo.value / 100;
        lastRow.getDataTupla('Close').Value = firstRow.getDataTupla('Close').Value;
      }
      fixedSeries.DataRows.push(firstRow);
      fixedSeries.DataRows.push(lastRow);

      result.push(fixedSeries);
    });

    return result;
  }
  /**
   * Insert all idrows in idrowsSelected
   */
  private insertIdRows(): void {
    // empty idrowsSelected
    this.idrowsSelected = [];

    // insert all idrows in idrowsSelected
    this.idrows.forEach((idrow: Id, index: number) => {
      // Create a DataRows from idrow
      const dataRow = new DataRow();
      dataRow.Id = idrow.key;

      if (this.colors.length > 0) {
        // set color
        dataRow.Color = this.colors[index % this.colors.length].key;
      }

      const rowToSubscribe = new RowToSubscribe(dataRow, this.publisherParameters);

      this.idrowsSelected.push(rowToSubscribe);
    });
  }
}
